import { useEffect, useRef, useState } from "react";
import { useShallow } from "zustand/react/shallow";
import { useFDAChangeManagementFlow } from "../../../hooks/useFDAChangeManagementFlow";
import { useFDAChangeManagementStore } from "../../../store/useFDAChangeManagementStore";
import Message from "../../Message";

const QuestionChat = () => {
  const messages = useFDAChangeManagementStore(
    useShallow((state) => state.questionMessages),
  );
  const selectedQuestion = useFDAChangeManagementStore(
    useShallow((state) => state.selectedQuestion),
  );
  const [input, setInput] = useState("");
  const chatRef = useRef(null);
  const [answerQuestion] = useFDAChangeManagementFlow();

  const sendMessage = async (ev) => {
    ev.preventDefault();
    if (!input.trim()) return;
    await answerQuestion({
      question: selectedQuestion,
      answer: "ask",
      ask: input,
    });
    setInput("");
  };

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <div className="flex h-full max-h-full flex-col overflow-hidden">
      <div
        ref={chatRef}
        className="flex min-h-0 flex-1 flex-col space-y-2 overflow-y-auto p-2"
        style={{ scrollBehavior: "smooth" }}
      >
        {messages.map((msg, index) => (
          <Message text={msg.text} sender={msg.sender} key={index} />
        ))}
        <div className="h-2"></div>
      </div>
      <div className="bg-base-100 mt-2 w-full flex-shrink-0">
        <form onSubmit={sendMessage}>
          <fieldset className="fieldset bg-base-200 border-base-300 rounded-box w-full border p-4">
            <label className="fieldset-label">
              Ask anything related to the question
            </label>

            <div className="join">
              <input
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                className="input join-item grow-1"
                placeholder="Type your message..."
              />
              <button className="btn join-item" type="submit">
                Send
              </button>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  );
};
export default QuestionChat;
